module.exports = "https://www.gc-pro.gnp.com.mx/3f19e5a748f070f5dd32749f77b450b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar_today_24px.png
// module id = 375
// module chunks = 0